import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

import Header from 'components/checkout/Header';
import { useCheckout } from '../../../context';
import TopBackgroundWrapper from 'components/checkout/TopBackgroundWrapper';
import CenteredContainer from 'components/CenteredContainer';
import OrgInfo from '../../OrgInfo';
import Products from './components/Products';
import SubmitSelectionButton from './components/SubmitSelectionButton';
import OrderSummary from './components/OrderSummary';
import SpecialCode from '../../SpecialCode';

function ProductsList() {
  const router = useRouter();
  const { t } = useTranslation(['organizations']);
  const { organization, user, cart, checkoutSession } = useCheckout();

  const onBack = () => {
    router.push(`/organizations/${organization.id}`);
  };

  return (
    <>
      <Header
        onBack={onBack}
        title={t('organizations:memberships.checkout.headerTitle')}
        subtitle={organization.name}
        isUserLoggedIn={!!user}
      />
      <TopBackgroundWrapper
        imageUrl={organization.coverImageUrl}
        hasTierNav={false}
        isUserLoggedIn={!!user}
      >
        <>
          {checkoutSession?.checkoutError?.message &&
            (checkoutSession.isCheckoutDisabled || cart.isEmpty) && (
              <div className="text-error text-center">
                {checkoutSession.checkoutError.message}
              </div>
            )}
          <div className="flex flex-1 flex-col gap-8 md:flex-row  md:items-center">
            <OrgInfo />
            <SpecialCode />
          </div>
        </>
      </TopBackgroundWrapper>
      <CenteredContainer hasPadding={false} wideContent>
        <div className="flex gap-8 pb-10">
          <Products />
          <OrderSummary />
        </div>
      </CenteredContainer>
      {!cart.isEmpty && (
        <div className="fixed bottom-0 left-0 right-0 bg-white px-4 pb-4 pt-2 border-neutral-200 border-t-1 md:hidden">
          <SubmitSelectionButton />
        </div>
      )}
    </>
  );
}

export default ProductsList;
